import React from "react";
import { Container, Typography, Grid, Card, CardContent, Box, Chip } from "@mui/material";
import { Work, MonetizationOn, Security, People, Search } from "@mui/icons-material";
import { motion } from "framer-motion";
import Footer from "../Footer";

const features = [
  {
    icon: <Work fontSize="large" />,
    title: "Strategic Flexibility",
    description:
      "Employ candidates on a contractual basis with the possibility of transitioning them to full-time roles based on performance and fit.",
  },
  {
    icon: <MonetizationOn fontSize="large" />,
    title: "Cost Efficiency",
    description:
      "Optimize recruitment expenses by ensuring candidates are well-suited to your organizational needs before making a long-term commitment.",
  },
  {
    icon: <Security fontSize="large" />,
    title: "Risk Reduction",
    description:
      "Minimize hiring risks by assessing candidates' skills, work ethic, and cultural alignment in an actual work environment.",
  },
  {
    icon: <People fontSize="large" />,
    title: "Continuous Talent Supply",
    description:
      "Keep a robust pipeline of qualified candidates ready to fill permanent positions, ensuring seamless operations.",
  },
];

const reasons = [
  "Deep understanding of technologies",
  "Recruitment and Sourcing expert",
  "Timely delivery and dedicated support",
  "Professional team and work culture",
];

const ContractToHire = () => {
  return (
    <>
    <Box sx={{ color: "#fff", py: 5 }}>
      <Container>
        <Typography variant="h3" gutterBottom align="center" sx={{ color: "#95a9bd", fontWeight: "bold" }}>
          Contract-to-Hire Staffing
        </Typography>
        <Typography variant="h6" align="center" sx={{ mb: 4, color: "#ccc" }}>
          Evaluate potential permanent hires in a real-world setting with strategic flexibility.
        </Typography>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div whileHover={{ scale: 1.05 }}>
                <Card sx={{ bgcolor: "#1c1c1c", color: "#007bff", borderRadius: 3, minHeight: 250 }}>
                  <CardContent>
                    <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                      {feature.icon}
                    </Box>
                    <Typography variant="h6" gutterBottom align="center">
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" align="center" color="#aaa">
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <Box mt={8} textAlign="center">
          <Typography variant="h4" sx={{ color: "#007bff", mb: 2 }}>
            Direct Recruitment
          </Typography>
          <Typography variant="body1" sx={{ maxWidth: 800, mx: "auto", color: "#ccc" }}>
            We provide tailor-made recruitment solutions across all verticals. Our expert team delivers world-class hiring strategies for top IT companies and startups. We work closely with our clients to find talent that drives their business.
          </Typography>
        </Box>

        <Box mt={6} textAlign="center">
          <Typography variant="h4" gutterBottom sx={{ color: "#95a9bd", p: 2  }}>
            Why Us?
          </Typography>
          <Grid container spacing={2} justifyContent="center">
            {reasons.map((reason, idx) => (
              <Grid item key={idx}>
                <motion.div
                  whileHover={{
                    scale: 1.1,
                    border: "2px solid #2196f3",
                    boxShadow: "0 0 8px #2196f3",
                  }}
                  style={{ borderRadius: "20px" }}
                >
                  <Chip
                    label={reason}
                    color="primary"
                    variant="outlined"
                    sx={{
                      fontSize: "1rem",
                      color: "#fff",
                      transition: "all 0.3s ease",
                      borderColor: "#2196f3",
                    }}
                  />
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
        <Footer />
</>
  );
};

export default ContractToHire;
